import "./KeyAdvantages.css";

export default function KeyAdvantages() {
  const steps = [
    "Verify your mobile number",
    "Confirm basic details",
    "Finalise your loan offer",
  ];

  return (
    <div className="w-full max-w-[400px] mx-auto px-4 pb-6 plv16-ka-root">
      <div
        className="w-full max-w-[360px] mx-auto rounded-[24px] px-[70px] py-[28px] bg-white plv16-ka-card"
        style={{
          boxShadow: "0px 0px 8px 0px #00000026",
          fontFamily:
            "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
        }}
      >
        <h2 className="text-[18px] font-semibold text-center leading-[24px] mb-6 text-gray-900 plv16-ka-heading">
          What happens next?
        </h2>

        <div className="flex flex-col gap-[25px] plv16-ka-steps">
          {steps.map((text, index) => (
            <div key={text} className="flex items-center gap-[14px] plv16-ka-step">
              <div className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center text-[14px] font-semibold">
                {index + 1}
              </div>
              <div className="text-[14px] leading-[18px] tracking-[-0.02em] text-gray-900 font-normal text-left plv16-ka-step-text">
                {text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
